import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  grid-gap: 10px;
  width: auto;
  padding: 30px 0 0;
`;
